"use client";

import { useSettingProductTileIteration } from "@faire/retailer-visitor-shared/settings/useSettingProductTileIteration";
import { Typography } from "@faire/web--source/slate/Typography";

export const MaybeBoldProductNameWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const showTileIterationChanges = useSettingProductTileIteration();
  return (
    <Typography
      className={className ?? "line-clamp-2 whitespace-normal"} 
      variant={
        showTileIterationChanges
          ? "paragraphSansRegular"
          : "paragraphSansMedium"
      }
      data-test-id="product-tile-product-name"
      style={{
        wordBreak: "break-word",
      }}
    >
      {children}
    </Typography>
  );
};
